import { Component } from 'react'

import ToastUtils from '@hotmart/cosmos/dist/toast/utils'

import '@hotmart/cosmos/dist/alert'
import '@hotmart/cosmos/dist/toast'
import '@hotmart/cosmos/dist/alert/variations/info.css'
import '@hotmart/cosmos/dist/alert/variations/success.css'
import '@hotmart/cosmos/dist/alert/variations/danger.css'
import '@hotmart/cosmos/dist/alert/variations/warning.css'
import './toast.scss'

export enum ToastPosition {
  BOTTOM_LEFT = 'bottom left',
  BOTTOM_RIGHT = 'bottom right',
  TOP_LEFT = 'top left',
  TOP_RIGHT = 'top right'
}

export default class Toast extends Component {
  private static defaultPosition: ToastPosition = ToastPosition.TOP_RIGHT

  private static buildToastPayload = (
    message: string,
    position: ToastPosition = Toast.defaultPosition
  ) => {
    return { message, position }
  }

  static danger = (message: string, position?: ToastPosition) => {
    ToastUtils.danger(Toast.buildToastPayload(message, position))
  }

  static error = Toast.danger

  static info = (message: string, position?: ToastPosition) => {
    ToastUtils.info(Toast.buildToastPayload(message, position))
  }

  static success = (message: string, position?: ToastPosition) => {
    ToastUtils.success(Toast.buildToastPayload(message, position))
  }

  static warning = (message: string, position?: ToastPosition) => {
    ToastUtils.warning(Toast.buildToastPayload(message, position))
  }

  render() {
    return (
      <hot-toast />
    )
  }
}
